import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { ApplicationSelectorStateModel, ApplicationSelectorFormValue } from 'src/app/model';

@State<ApplicationSelectorStateModel>({
  name: 'applicationSelector',
  defaults: {
    applicationForm: {
      model: undefined,
      dirty: false,
      status: '',
      errors: {},
    },
  },
})
@Injectable()
export class ApplicationSelectorState {
  @Selector()
  static applicationSelectorFormValues(state: ApplicationSelectorStateModel): ApplicationSelectorFormValue {
    return state.applicationForm.model;
  }

  @Selector()
  static application(state: ApplicationSelectorStateModel): string {
    return state.applicationForm.model?.application?.value ?? '';
  }

  @Selector()
  static environment(state: ApplicationSelectorStateModel): string {
    return state.applicationForm.model?.environment?.value ?? '';
  }
}
